const tabIds = {
  DOMAIN_PURCHASE: 'domain_purchase',
  DOMAIN_POINTING: 'domain_pointing',
};

export default tabIds;
